import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import React, { useEffect, useState } from "react";
import SelectableSearch from "../../base/views/SelectableSearch";
import { Form } from "../../base/views/useForm";
import {
  GetCityDropDownData,
  GetCountryDropDownData,
  GetStateDropDownData,
} from "../../SignUp/helper/signUpHelper";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
  },
}));

const initialFValues = {
  employeeid: 0,
  storeid: "",
  firstname: "",
  middlename: "",
  lastname: "",
  dob: null,
  street1: "",
  street2: "",
  country: { id: 0, optionname: "" },
  state: { id: 0, optionname: "" },
  city: { id: 0, optionname: "" },
  emergencycontactno: "",
  mobileno: "",
  email: "",
  idproof: "",
  joindate: null,
  lastworkingdate: null,
};

export default function EmployeeForm(props) {
  const classes = useStyles();
  const [countryData, setCountryData] = useState({
    load: false,
    values: [],
  });
  const [stateData, setStateData] = useState({
    load: false,
    values: [],
  });
  const [cityData, setCityData] = useState({
    load: false,
    values: [],
  });
  const [errors, setErrors] = React.useState({});
  const [addEmployeeData, setState] = useState(initialFValues);

  const validate = (fieldValues = addEmployeeData) => {
    let temp = {};
    if ("firstname" in fieldValues) {
      temp.firstname =
        fieldValues.firstname === "" ? "First Name is required" : "";
    }
    if ("lastname" in fieldValues) {
      temp.lastname =
        fieldValues.lastname === "" ? "Last Name is required" : "";
    }
    if ("dob" in fieldValues) {
      temp.dob = fieldValues.dob === null ? "DOB is required" : "";
    }
    if ("street1" in fieldValues) {
      temp.street1 =
        fieldValues.street1 === "" ? "Address Lane 1 is required" : "";
    }
    if ("country" in fieldValues) {
      temp.country =
        fieldValues.country.optionname && fieldValues.country.optionname !== ""
          ? ""
          : "Country is required";
    }

    if ("state" in fieldValues) {
      temp.state =
        fieldValues.state.optionname && fieldValues.state.optionname !== ""
          ? ""
          : "State is required";
    }

    if ("city" in fieldValues) {
      temp.city =
        fieldValues.city.optionname && fieldValues.city.optionname !== ""
          ? ""
          : "City is required";
    }
    if ("email" in fieldValues)
      temp.email =
        fieldValues.email === ""
          ? "Email is required"
          : /$^|.+@.+..+/.test(fieldValues.email)
          ? ""
          : "Email is not valid";
    if ("mobileno" in fieldValues)
      temp.mobileno =
        fieldValues.mobileno.length < 10
          ? "Invalid mobile no. 10 digits required"
          : fieldValues.mobileno.length > 10
          ? "Maximum length exceeded"
          : "";
    if (
      "emergencycontactno" in fieldValues &&
      fieldValues.emergencycontactno.length !== 0
    )
      temp.emergencycontactno =
        fieldValues.emergencycontactno.length < 10
          ? "Invalid mobile no. 10 digits required"
          : fieldValues.emergencycontactno.length > 10
          ? "Maximum length exceeded"
          : "";
    if ("joindate" in fieldValues)
      temp.joindate =
        fieldValues.joindate === null ? "Joining Date is required" : "";

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addEmployeeData,
      [name]: value,
    });
  };

  const handleCountryChange = (event, value) => {
    if (value && value.id) {
      setState({
        ...addEmployeeData,
        country: { id: value.id, optionname: value.optionname },
        state: {},
        city: {},
      });
    }
    setStateData({ ...stateData, values: [] });
    setCityData({ ...cityData, values: [] });
  };

  const handleStateChange = (event, value) => {
    setCityData({ values: [], ...cityData });
    if (value && value.id) {
      setState({
        ...addEmployeeData,
        state: {
          id: value.id,
          optionname: value.optionname,
          city: {},
        },
      });
    }
  };

  const handleCityChange = (event, value) => {
    if (value && value.id) {
      setState({
        ...addEmployeeData,
        city: { id: value.id, optionname: value.optionname },
      });
    }
  };

  const handleDobDateChange = (date) => {
    setState({
      ...addEmployeeData,
      dob: date,
    });
  };

  const handleJoinDateChange = (date) => {
    setState({
      ...addEmployeeData,
      joindate: date,
    });
  };

  const handleLwdDateChange = (date) => {
    setState({
      ...addEmployeeData,
      lastworkingdate: date,
    });
  };

  const loadingCountry = () => {
    setCountryData({ ...countryData, load: true });
    GetCountryDropDownData()
      .then((response) => {
        setCountryData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingState = (countryId = 0) => {
    setStateData({ ...stateData, load: true });
    var params = { country_id: countryId };
    GetStateDropDownData(params)
      .then((response) => {
        setStateData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingCity = (stateId = 0) => {
    setCityData({ ...cityData, load: true });
    var params = { state_id: stateId };
    GetCityDropDownData(params)
      .then((response) => {
        setCityData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const { addOrEdit, recordForEdit, addEmployee, editEmployee } = props;

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (addEmployeeData.employeeid === 0)
        addEmployee({ ...addEmployeeData, storeid: props.storeid });
      else editEmployee({ ...addEmployeeData, storeid: props.storeid });

      addOrEdit(resetForm);
    }
  };
  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={HandleSubmit}>
      <Container component="main" maxWidth="lg">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.firstname}
                onChange={handleInputChange}
                autoComplete="fname"
                name="firstname"
                variant="outlined"
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
                {...(errors.firstname && {
                  error: true,
                  helperText: errors.firstname,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.middlename}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="middlename"
                label="Middle Name"
                name="middlename"
                autoComplete="mname"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.lastname}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="lastname"
                label="Last Name"
                name="lastname"
                autoComplete="lname"
                {...(errors.lastname && {
                  error: true,
                  helperText: errors.lastname,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="dob"
                    name="dob"
                    label="DOB"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={addEmployeeData.dob}
                    onChange={handleDobDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.dob && {
                      error: true,
                      errortext: errors.dob,
                      helperText: errors.dob,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.street1}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="street1"
                label="Address Line 1"
                name="street1"
                autoComplete="s1name"
                {...(errors.street1 && {
                  error: true,
                  helperText: errors.street1,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.street2}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="street2"
                label="Address Line 2"
                name="street2"
                autoComplete="s2name"
                {...(errors.street2 && {
                  error: true,
                  helperText: errors.street2,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <SelectableSearch
                value={addEmployeeData.country}
                data={countryData}
                name="country"
                label="Country"
                id="country"
                loading={loadingCountry}
                onChangeEvent={handleCountryChange}
                {...(errors.country && {
                  error: true,
                  helperText: errors.country,
                })}
              ></SelectableSearch>
            </Grid>
            <Grid item xs={4}>
              <SelectableSearch
                value={addEmployeeData.state}
                data={stateData}
                name="state"
                label="State"
                id="state"
                loading={() => loadingState(addEmployeeData.country.id)}
                onChangeEvent={handleStateChange}
                {...(errors.state && {
                  error: true,
                  helperText: errors.state,
                })}
              ></SelectableSearch>
            </Grid>
            <Grid item xs={4}>
              <SelectableSearch
                value={addEmployeeData.city}
                data={cityData}
                name="city"
                label="City"
                id="city"
                loading={() => loadingCity(addEmployeeData.state.id)}
                onChangeEvent={handleCityChange}
                {...(errors.city && {
                  error: true,
                  helperText: errors.city,
                })}
              ></SelectableSearch>
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.emergencycontactno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                type="number"
                id="emergencycontactno"
                label="Emergency Contact No"
                name="emergencycontactno"
                autoComplete="emergencyContactNo"
                {...(errors.emergencycontactno && {
                  error: true,
                  helperText: errors.emergencycontactno,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.mobileno}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                type="number"
                id="mobileno"
                label="Mobile No"
                name="mobileno"
                autoComplete="mobileno"
                {...(errors.mobileno && {
                  error: true,
                  helperText: errors.mobileno,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.email}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                {...(errors.email && { error: true, helperText: errors.email })}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                value={addEmployeeData.idproof}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                name="idproof"
                label="ID Proof"
                type="text"
                id="idProof"
                {...(errors.idproof && {
                  error: true,
                  helperText: errors.idproof,
                })}
              />
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="joiningDatePicker"
                    label="Joining Date"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={addEmployeeData.joindate}
                    onChange={handleJoinDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.joindate && {
                      error: true,
                      errortext: errors.joindate,
                      helperText: errors.joindate,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    margin="normal"
                    id="lastWorkingDatePicker"
                    label="Last Working Date"
                    format="MM/dd/yyyy"
                    autoOk={true}
                    okLabel={""}
                    cancelLabel={""}
                    value={addEmployeeData.lastworkingdate}
                    onChange={handleLwdDateChange}
                    className={classes.submit}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    {...(errors.lastworkingdate && {
                      error: true,
                      helperText: errors.lastworkingdate,
                    })}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              style={{
                width: "20vw",
                backgroundColor: "rgb(22, 177, 255)",
                borderRadius: "0.5rem",
              }}
              type="submit"
            >
              Save
            </Button>
          </div>
        </div>
      </Container>
    </Form>
  );
}
